import { render } from "./User.vue?vue&type=template&id=c83649ca&scoped=true"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"

import "./User.vue?vue&type=style&index=0&id=c83649ca&lang=scss&scoped=true"
import "./User.vue?vue&type=style&index=1&id=c83649ca&lang=scss"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c83649ca"]])

export default __exports__